export default "__VITE_ASSET__D5ylAfOT__"